import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import ProdutoModel from "../model/ProdutoModel";
import NavegadorUtil from "../util/NavegadorUtil";
import ModalListas from "./ModalListas";
import { Snackbar } from "@material-ui/core";
import AppState from "../model/AppState";
import AlertaModel from "../model/AlertaModel";
import Produto from "../Produto";

import { ReactComponent as ImagemCompartilhar } from "../assets/images/icons/compartilhar.svg";
import { ReactComponent as ImagemLista } from "../assets/images/icons/lista.svg";
import { ReactComponent as ImagemMenuPontos } from "../assets/images/icons/menu-pontos.svg";
import { ReactComponent as ImagemMenuFechar } from "../assets/images/icons/floating-menu-close.svg";

type RodapeProdutoContextoProps = {
  titulo?: string,
  produto: ProdutoModel,
  parent: Produto,
  children?: ReactNode
};

type RodapeProdutoContextoState = {
  showModalListas: boolean,
  showNovaListaForm: boolean
};

class RodapeProdutoContexto extends React.Component<RodapeProdutoContextoProps, RodapeProdutoContextoState> {

  constructor(props:RodapeProdutoContextoProps) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.share = this.share.bind(this);
    this.toggleModalLista = this.toggleModalLista.bind(this);

    this.state = {
      showModalListas: false,
      showNovaListaForm: false,
    };
  }

  toggleMenu(): any {
    const menuContextoJanela: any = ReactDOM.findDOMNode(this.refs.menuContextoJanela);
    if (menuContextoJanela.style.display === "none" || menuContextoJanela.style.display === "") {
      menuContextoJanela.style.display = "block";
    } else {
      menuContextoJanela.style.display = "none";
    }
  }

  hideMenu(): any {
    const menuContextoJanela: any = ReactDOM.findDOMNode(this.refs.menuContextoJanela);
    menuContextoJanela.style.display = "none";
  }

  share(): void {
    let titulo: string = "Oba Hortifruti";
    const { produto } = this.props;
    if (produto) {
      titulo = `${titulo} - ${produto.nome}`;
    }
    NavegadorUtil.share(titulo, "Vem conferir no Oba !", window.location.href);
  }

  toggleModalLista(): void {
    this.setState({ showModalListas: !this.state.showModalListas });
  }

  render(): any {

    let alerta: any = AppState.getAlerta();

    if (!alerta) {
      alerta = {
        exibirModal: false,
      } as AlertaModel;
    }

    return (
      <>
        <Snackbar
          open={alerta.exibirModal}
          className="info product"
          onClose={() => AppState.fecharAlerta(this)}
          transitionDuration={1000}
          autoHideDuration={6000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{alerta.mensagem}</span>}
        />
        <ModalListas
          produto={ this.props.produto }
          toggleModalLista={ this.toggleModalLista }
          visivel={ this.state.showModalListas }
          parent={ this.props.parent }
        />
        <footer className="context-menu-window" ref="menuContextoJanela" onClick={ this.hideMenu }>
          <div>
            <button onClick={ this.share } >
              <ImagemCompartilhar /> Compartilhar
            </button>
          </div>
          <div>
            <button onClick={this.toggleModalLista}>
              <ImagemLista /> Adicionar a uma lista
            </button>
          </div>
        </footer>
        <footer className="context-menu" ref="menuContexto" onClick={ this.toggleMenu }>
          <ImagemMenuPontos className="open" />
          <ImagemMenuFechar className="close" />
        </footer>
      </>
    );
  }
}

export default RodapeProdutoContexto;